import { IOperation } from "interfaces/operations/Operations";
import { IMasterDataItem } from "interfaces/masterData/masterDataInterfaces";

export interface IMasterDataState {
  activityWorkflows: IMasterDataSection;
  competencyElements: IMasterDataSection;
  countries: IMasterDataSection;
  geoUnits: IMasterDataSection;
  equipment: IMasterDataSection;
  epicEquipment: IMasterDataSection;
  equivalentSWs: IMasterDataSection;
  languages: IMasterDataSection;
  operatingEnvironments: IMasterDataSection;
  organizations: IMasterDataSection;
  plants: IMasterDataSection;
  customers: IMasterDataSection;
  safetyCategories: IMasterDataSection;
  businessRoles: IMasterDataSection;
  productCenters: IMasterDataSection;
  serviceTypes: IMasterDataSection;
  tasks: IMasterDataSection;
  taskAlignments: IMasterDataSection;
  types: IMasterDataSection;
  globalOrLocalTypes: IMasterDataSection;
  approvalLevels: IMasterDataSection;
  feedbackTypes: IMasterDataSection;
  subBusinessLines: IMasterDataSection;
  owningPlants: IMasterDataSection;
  performingPlants: IMasterDataSection;
  materials: IMasterDataSection;
  gemsRevisionNumbers: IMasterDataSection;
  workCenters: IMasterDataSection;
  hazardCategories: IMasterDataSection;
  potentialLosses: IMasterDataSection;
  dataClassificationTypes: IMasterDataSection;
  operationTree: IOperationTreeModel | undefined;
  groups: IMasterDataSection;
  groupCounter: IMasterDataSection;
  qTracOOS: IMasterDataSection;
  maintenanceTasksPerEvent: IMasterDataSection;
  uoms: IMasterDataSection;
  meters: IMasterDataSection;
  events: IMasterDataSection;
  customizedEvents: IMasterDataSection;
  currentOwningPlants: IMasterDataSection;
  autoTranslateLanguages: IMasterDataSection;
  maintenanceTasks: IMasterDataSection;
  systemMessages: ISystemMessages[],
  mviModels: IMasterDataSection;
}

export interface IMasterDataSection {
  items: IMasterDataItem[];
  loadOperation?: IOperation;
}

export type MetaDataNames =
  | "activityWorkflows"
  | "approvalLevels"
  | "competencyElements"
  | "countries"
  | "geoUnits"
  | "equipment"
  | "epicEquipment"
  | "equivalentSWs"
  | "languages"
  | "operatingEnvironments"
  | "owningOrgs"
  | "performingOrgs"
  | "subBusinessLines"
  | "safetyCategories"
  | "serviceTypes"
  | "tasks"
  | "taskAlignments"
  | "businessRoles"
  | "productCenters"
  | "customers"
  | "globalOrLocalTypes"
  | "dataClassificationTypes"
  | "types"
  | "feedbackTypes"
  | "owningPlants"
  | "performingPlants"
  | "materials"
  | "gemsRevisionNumber"
  | "workCenters"
  | "hazardCategories"
  | "groups"
  | "groupCounter"
  | "qTracOOS"
  | "uoms"
  | "meters"
  | "customizedEvents"
  | "events"
  | "currentOwningPlants"
  | "connectedSWIs"
  | "autoTranslateLanguages"
  | "maintenanceTasks"
  | "privateSWTypes"
  | "mviModels";

export type MasterDataSectionNames =
  | "activityWorkflows"
  | "competencyElements"
  | "countries"
  | "geoUnits"
  | "equipment"
  | "epicEquipment"
  | "equivalentSWs"
  | "languages"
  | "operatingEnvironments"
  | "organizations"
  | "subBusinessLines"
  | "safetyCategories"
  | "businessRoles"
  | "productCenters"
  | "customers"
  | "serviceTypes"
  | "tasks"
  | "taskAlignments"
  | "globalOrLocalTypes"
  | "dataClassificationTypes"
  | "types"
  | "feedbackTypes"
  | "owningPlants"
  | "performingPlants"
  | "materials"
  | "gemsRevisionNumbers"
  | "workCenters"
  | "hazardCategories"
  | "groups"
  | "groupCounter"
  | "qTracOOS"
  | "uoms"
  | "meters"
  | "customizedEvents"
  | "events"
  | "currentOwningPlants"
  | "potentialLosses"
  | "autoTranslateLanguages"
  | "maintenanceTasks"
  | "mviModels"
  | "maintenanceTasksPerEvent";


export interface IOperationTreeModel {
  nodes: IOperationTreeNode[];
  links: IOperationTreeLink[];
}

export interface IOperationTreeNode {
  materialCode: string;
  plantCode: string;
  group: string;
  groupCounter: number;
  sequence: number;
  taskListNode: number;
  startBranchOperation?: number;
  returnOperation?: number;
  operation: string;
  operationText: string;
  text: string;
}

export interface IOperationTreeLink {
  from: string;
  to: string;
}

export interface IQTracOOS {
  code: string;
  name: string;
}

export enum SystemMessageTypes {
  Warning = "Warning",
  Caution = "Caution",
  Info = "Info",
}

export interface ISystemMessages {
  id: number
  message: string,
  messageType: SystemMessageTypes,
}